import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Notifications from "./dropdown-notifications";
import UserMenu from "./dropdown-profile";
import Breadcrumbs from "./Breadcrumbs";
import SearchModal from "./modal-search";

// Redux
import { useSelector } from "react-redux";
import HelpCenter from "./help-center";

function Header({
  sidebarOpen,
  setSidebarOpen,
  notificationList,
  setNotificationList,
}) {
  const { performanceHeader } = useSelector((state) => state.performance);
  const userData = useSelector((state) => state.auth);
  const { performancedata, tododata } = useSelector(
    (state) => state.todoPerformance
  );
  const { configurationHeaderName } = useSelector(
    (state) => state.configurationReducer
  );

  const { bookingTemplateHeaderName } = useSelector(
    (state) => state.bookingTemplate
  );

  const salesOrder = useSelector(state => state.salesOrder);
  const purchaseOrder = useSelector(state => state.purchaseOrder);

  const location = useLocation();
  const { pathname } = location;

  const [width, setWidth] = useState(window.innerWidth);
  const [searchmodal, setSearchModal] = useState(false);

  const windowResize = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", windowResize);
  }, [window.innerWidth]);

  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const timerID = setInterval(() => tick(), 1000);
    return () => clearInterval(timerID);
  }, []);

  function tick() {
    setDate(new Date());
  }

  // console.log({tododata, performancedata})

  return (
    <header className="sticky top-0 bg-white py-2 z-30">
      <div className="px-4 sm:px-6 lg:px-8">
        <Breadcrumbs />
        <div className="flex items-start h-12 -mb-px ">
          {/* Header: Left side */}
          <div
            className={`flex items-center px-0 ${
              width < 1130 ? "max-w-2/3" : "max-w-full"
            } truncate overflow-hidden`}
          >
            {/* Hamburger button */}
            <button
              className="text-slate-500 hover:text-slate-600 lg:hidden"
              aria-controls="sidebar"
              aria-expanded={sidebarOpen}
              onClick={(e) => {
                e.stopPropagation();
                setSidebarOpen(!sidebarOpen);
              }}
            >
              <span className="sr-only">Open sidebar</span>
              <svg
                className="w-6 h-6 fill-current"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="4" y="5" width="16" height="2" />
                <rect x="4" y="11" width="16" height="2" />
                <rect x="4" y="17" width="16" height="2" />
              </svg>
            </button>

            {pathname === "/" ||
            pathname.includes("dashboard") ||
            pathname.includes("/calendar") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Overview
              </h1>
            ) : null}

            {pathname.includes("booking/overview") ||
            pathname.includes("booking/create") ||
            pathname.includes("/booking/update") ||
            pathname.includes("/booking/integration") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Bookings
              </h1>
            ) : null}

            {pathname.includes("analytics") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Analytics
              </h1>
            ) : null}

            {pathname.includes("chat") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Chat
              </h1>
            ) : null}

            {pathname.includes("requests/overview") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Requests
              </h1>
            ) : null}

            {pathname.includes("workflows") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Manage Workflows
              </h1>
            ) : null}

            {pathname.includes("configuration/create") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Create New Workflow
              </h1>
            ) : null}

            {pathname.includes("configuration/view") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                {configurationHeaderName
                  ? "Workflow " + configurationHeaderName
                  : null}
              </h1>
            ) : null}

            {pathname.includes("configuration/update") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                {configurationHeaderName
                  ? "Workflow " + configurationHeaderName
                  : null}
              </h1>
            ) : null}

            {pathname.includes("activity/overview") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Manage To Dos
              </h1>
            ) : null}

            {pathname.includes("activity/create") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Create New To Do
              </h1>
            ) : null}

            {pathname.includes("activity/update") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Update To Do
              </h1>
            ) : null}

            {pathname.includes("/myaccount") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Account
              </h1>
            ) : null}

            {pathname.includes("/users") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Internal & External Users
              </h1>
            ) : null}

            {pathname.includes("/departments") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Teams
              </h1>
            ) : null}

            {pathname.includes("/assets") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Assets
              </h1>
            ) : null}

            {pathname.includes("/billingplans") ||
            pathname.includes("/billingdetails") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Billing & Plan Details
              </h1>
            ) : null}

            {pathname.includes("/accessToken") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Access Token
              </h1>
            ) : null}

            {pathname.includes("/stakeholders") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Stakeholders
              </h1>
            ) : null}

            {pathname.includes("/assignment/assign") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Assignment
              </h1>
            ) : null}

            {pathname.includes("/todo/performance") ? (
              <h1
                title={performancedata?.internal_booking_ref_id}
                className="text-xl md:text-3xl text-slate-800 font-bold w-full truncate overflow-hidden"
              >
                {performancedata?.internal_booking_ref_id}
                {performancedata?.alias && (
                  <span className="font-semibold">
                    &nbsp;|&nbsp;{performancedata?.alias}
                  </span>
                )}
              </h1>
            ) : null}

            {pathname.includes("/booking/design/overview") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Manage Booking Templates
              </h1>
            ) : null}

            {pathname.includes("/booking/design/update") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                {bookingTemplateHeaderName
                  ? "Booking Template " + bookingTemplateHeaderName
                  : null}
              </h1>
            ) : null}

            {pathname.includes("/booking/design/create") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Create Booking Template
              </h1>
            ) : null}

            {pathname.includes("/invoice") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Invoice
              </h1>
            ) : null}
            {pathname.includes("/notifications") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Notifications
              </h1>
            ) : null}

            {pathname.includes("/component") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Manage Components
              </h1>
            ) : null}

            {pathname.includes("/sku/overview") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                SKU Master
              </h1>
            ) : null}

            {pathname.includes("/sku/create") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Create SKU
              </h1>
            ) : null}

            {pathname.includes("/sku/update") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Update SKU
              </h1>
            ) : null}

            {pathname.includes("/product/overview") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Product Master
              </h1>
            ) : null}

            {pathname.includes("/product/create") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Create New Product
              </h1>
            ) : null}

            {pathname.includes("/product/update") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Update Product
              </h1>
            ) : null}

            {pathname.includes("/order/overview") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Order Overview
              </h1>
            ) : null}

            {pathname.includes("/inventory/overview") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Inventory
              </h1>
            ) : null}

            {pathname.includes("/order/create_sales_order") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                { salesOrder?.headerValue ? salesOrder.headerValue : "Create Sales Order" }
              </h1>
            ) : null}

            {pathname.includes("/order/update_sales_order") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                { salesOrder?.headerValue ? salesOrder.headerValue : "Update Sales Order" }
              </h1>
            ) : null}

            {pathname.includes("/order/create_purchase_order") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                { purchaseOrder?.headerValue ? purchaseOrder.headerValue : "Create Purchase Order" }
              </h1>
            ) : null}

            {pathname.includes("/order/update_purchase_order") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                { purchaseOrder?.headerValue ? purchaseOrder.headerValue : "Update Purchase Order" }
              </h1>
            ) : null}

            {pathname.includes("/order/create_production_order") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Create Production Order
              </h1>
            ) : null}

            {pathname.includes("/order/update_production_order") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Update Production Order
              </h1>
            ) : null}

            {pathname.includes("/customization") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                White Labeling
              </h1>
            ) : null}

            {pathname.includes("/working-hours") ? (
              <h1 className="text-xl md:text-3xl text-slate-800 font-bold">
                Working Hours
              </h1>
            ) : null}
          </div>

          {/* Header: Right side */}
          <div className="grow flex items-center justify-end space-x-3 ml-auto">
            <div>
              {userData.type !== "customer" &&
                userData.type !== "collaborator" && (
                  <button
                    className={`w-8 h-8 flex items-center justify-center bg-slate-100 hover:bg-slate-200 transition duration-150 rounded-full ml-3 ${
                      searchmodal && "bg-slate-200"
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSearchModal(true);
                    }}
                    aria-controls="search-modal"
                  >
                    <span className="fa-solid fa-magnifying-glass"></span>
                  </button>
                )}

              <SearchModal
                id="search-modal"
                searchId="search"
                modalOpen={searchmodal}
                setModalOpen={setSearchModal}
              />
            </div>
            <hr
              className={`${
                userData.type === "customer" || userData.type === "collaborator"
                  ? "hidden"
                  : "block"
              } w-px h-6 bg-slate-200 mx-3`}
            />
            {/* {userData.type !== "customer" &&
              userData.type !== "collaborator" && ( */}
            <Notifications
              align="right"
              notificationList={notificationList}
              setNotificationList={setNotificationList}
            />
            {/* )} */}

            <hr
              className={`${
                userData.type === "customer" || userData.type === "collaborator"
                  ? "hidden"
                  : "block"
              } w-px h-6 bg-slate-200 mx-3`}
            />
            <HelpCenter align="right" />
            <hr className="block w-px h-6 bg-slate-200 mx-3" />
            <UserMenu align="right" />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
